export default {
    activities_main_id: 'Id',
    activities_main_username: 'Username',
    activities_main_controller: 'Controller',
    activities_main_action: 'Action',
    activities_main_date_time: 'Date and Time',
    activities_main_source: 'Source',
    activities_main_url: 'Url',
    activities_main_method: 'Method',
    activities_main_ip_address: 'Ip Address',
    activities_main_platforms: 'Platforms',
    activities_main_entity_name: 'Entity Name',
    activities_main_entity_id: 'Entity Id',
    activities_main_parameters: 'Parameters',
    activities_main_new_values: 'New Values',
    activities_main_error_message: 'It is necessary to select an account',
    activities_main_apply_filters: 'Apply filters',
    activities_main_user_activity_logs: 'User Activity Logs',
    activities_main_account: 'Account',
    activities_main_actions: 'Actions',
    activities_main_time_frame: 'Time Frame',
    activities_main_apply: 'Apply',
    activities_main_search_controller: 'Search by Controller',
};

